var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0959 8.65568L11.5129 12.809H8.44864V22H4.33906V12.809H1V8.65568H4.33906V6.34017C4.33906 2.73965 6.30141 0.75 9.3065 0.75C10.7449 0.75 12.25 1.03063 12.25 1.03063V4.56658H10.5908C8.95719 4.56658 8.44864 5.67509 8.44864 6.81163V8.65568H12.0959Z",
    fill: "white",
    stroke: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f.01a83ec69717cefd4993d4d7159eb9e7.svg";
export { ForwardRef as ReactComponent };